// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    timeStamps: Partial<Record<This.MetadataFile.Id, Date>>;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Toolbox-ManageMetadata',
    templateUrl: './ManageMetadata.html',
    styleUrls: ['./ManageMetadata.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ManageMetadata extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Toolbox.ManageMetadata';
    $isDialog = false;
    $Modules = $Modules;
    Toolbox = Toolbox;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_timeStamps = proxySignal<Partial<Record<This.MetadataFile.Id, Date>>>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get timeStamps() { return component.var_timeStamps() },
                set timeStamps(value: Partial<Record<This.MetadataFile.Id, Date>>) { component.var_timeStamps.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.timeStamps = ({})
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    _ForBlock_collectionCode_58($scope: any): any[] {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return (This.MetadataFile.getEntryList() as any[])
    }

    async handler_ButtonBlock_63_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { file, fileIndex, $disabled }: { file: This.MetadataFile.Entry, fileIndex: number, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    const data = await This.MetadataHelper.download(file.id as This.MetadataFile.Id)
                    Sys.App.provideDownload(data, file.path)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_FileUploadBlock_64_filesSelected_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { file, fileIndex, $disabled }: { file: This.MetadataFile.Entry, fileIndex: number, $disabled: any } = $scope ?? {}

        {
            let files: File[] = [...$event]
            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (!files.length) return
                    await This.MetadataHelper.upload(file.id as This.MetadataFile.Id, await files[0].arrayBuffer())
                    Sys.App.showNotification('success', 'File updated successfully')
                    this.action_reloadTimestamps($event)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            await this.action_reloadTimestamps($event)
        }
    }

    async action_reloadTimestamps($event?: any) {
        const { app, screen, output } = this
        {
            screen.timeStamps = await This.MetadataHelper.getTimestamps()
        }
    }
}
